import { InternalAxiosRequestConfig } from 'axios';

const _sessionId = genSessionId(8);

export const sessionID = _sessionId;

function genSessionId(length = 8): string {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
}

export function sessionIdInterceptor(config: InternalAxiosRequestConfig) {
  config.headers.set('TraceAir-Session-Id', sessionID);

  return config;
}
